<template>
    <div :class="headerClass">
        <ul
            class="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-m-0 tw-border-b tw-border-gray-200 tw-bg-white tw-px-1 tw-pt-1 tw-text-sm tw-text-center tw-text-gray-500"
            :class="headerClass"
        >
            <li v-for="(tab, index) in tabs" :key="index" :class="tab.headerClass">
                <button
                    v-if="!tab.hidden"
                    class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-t-md tw-border tw-border-b-0 tw-px-3 tw-py-2 tw-leading-5 tw-transition-all tw-duration-150 tw-ease-out hover:tw-bg-slate-50 hover:tw-text-slate-700 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-sky-200"
                    :class="[
                        headingClass,
                        {
                            'tw-top-px !tw-border-gray-200 tw-bg-white tw-text-eventwise hover:tw-bg-white hover:!tw-text-eventwise tw-font-medium':
                                model === tab.name,
                            'tw-border-transparent tw-text-slate-500': model !== tab.name,
                        },
                    ]"
                    @click="model = tab.name"
                >
                    <slot :name="`heading(${tab.name})`">
                        {{ tab.title }}
                    </slot>
                </button>
            </li>
        </ul>
    </div>
    <div :class="containerClass">
        <div v-for="(tab, index) in tabs" v-show="model === tab.name" :key="index" :class="[contentClass, tab.class]">
            <slot v-if="$slots[`tab(${tab.name})`]" :name="`tab(${tab.name})`"></slot>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, provide } from 'vue';

const props = defineProps<{
    tabs: Array<{
        name: string;
        title: string;
        hidden?: boolean;
        headerClass?: string;
        class?: string;
    }>;
    headerClass?: string;
    headingClass?: string;
    contentClass?: string;
    containerClass?: string;
}>();

const model = defineModel({
    type: String,
    default: null,
});

onMounted(() => {
    if (!model.value && props.tabs.length > 0) {
        model.value = props.tabs[0].name;
    }
});
// DO NOT REMOVE this as required by Textarea
provide('activeTab', model);

defineExpose({
    model,
});
</script>
